import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Params } from '@angular/router';
import { LogService, ServiceRouter } from '@pershing/pershing-core';
import { NXIRestServiceDefinition } from './NXI-Rest-service-definition';
import { Observable, BehaviorSubject } from 'rxjs';
import { ModernRateBoardServiceDefinition } from './modern-rateboard-service.definition';

@Injectable()
export class NxiRestService {
    public serviceUrl: string;
    public rateboardServiceUrl: string;
    public jsonFormHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
    accountList$: BehaviorSubject<any> = new BehaviorSubject([]);
    accountListObservable$ = this.accountList$.asObservable();
    constructor(private http: HttpClient, private logService: LogService, private serviceRouter: ServiceRouter) {
        logService.info('NxiRestService : constructor Initializing');
        this.serviceUrl = this.serviceRouter.getServiceRouteURL(NXIRestServiceDefinition.getInstance());
        this.rateboardServiceUrl= this.serviceRouter.getServiceRouteURL(ModernRateBoardServiceDefinition.getInstance());
        // this.serviceUrl = 'http://dev-advisor-netxinvestor.bnymellon.net:8080/services/netxclient.rest-service';
        logService.info('NxiRestService : URL', this.serviceUrl);
    }

    public getRestResponse(): Observable<any> {
        let timeNow = Date.now();
        this.logService.info('NxiRestService : getting Messages');
        return this.http.get(this.serviceUrl + '?time=' + timeNow);
    }

    public getDaVendors(): Observable<any> {
        let timeNow = Date.now();
        this.logService.info('NxiRestService : getting DA Vendors');
        return this.http.get('/getDaVendors' + '?time=' + timeNow);
    }

    public getNxiRestUrlResponse(nxiRestUrl: string): Observable<any> {
        let timeNow = Date.now();
        return this.http.get(nxiRestUrl + '?time=' + timeNow);
    }

    public getNxiPortfolioRestUrlResponse(nxiRestUrl: string): Observable<any> {
        let timeNow = Date.now();
        return this.http.get(this.serviceUrl + '/portfolio/' + nxiRestUrl + '?time=' + timeNow);
    }

    public getNxiPortfolioRestResponse(acctresp: string, url: string): Observable<any> {
        console.log('Getting NXI widget Params for ', url);
        if (acctresp !== '' && acctresp !== undefined) {
            const options = {
                headers: new HttpHeaders().append('Account', acctresp)
            };
            return this.http.get(this.serviceUrl + '/portfolio/' + 'urn:id:headers.Account' + '/' + url, options);
        } else {
            return this.http.get(this.serviceUrl + '/portfolio/' + acctresp + '/' + url);
        }
    }
    public getNxiAWRPortfolioRestResponse(acctresp: string, url: string): Observable<any> {
        console.log('Getting NXI widget Params for ', url);
        if (acctresp !== '' && acctresp !== undefined) {
            const options = {
                headers: new HttpHeaders().append('Account', acctresp)
            };
            return this.http.get(this.serviceUrl + '/portfolio/' + acctresp + '/' + url, options);
        } else {
            return this.http.get(this.serviceUrl + '/portfolio/' + acctresp + '/' + url);
        }
    }

    public getNxiMAPerfRestResponse(acctresp: string, url: string): Observable<any> {
        console.log('Getting NXI rest response for ', url);
        if (acctresp !== '' && acctresp !== undefined) {
            const options = {
                headers: new HttpHeaders().append('Account', acctresp)
            };
            return this.http.get(this.serviceUrl + '/maperformance/' + 'urn:id:headers.Account' + '/' + url, options);
        } else {
            return this.http.get(this.serviceUrl + '/maperformance/' + acctresp + '/' + url);
        }
    }

    public getNxiDPRPerfRestUrl(acctresp: string, url: string): string {

        url = this.serviceUrl + '/maperformance/' + acctresp + '/' + url;
        return url;
    }

    public getNxiPayBillsRestResponse(url: string): Observable<any> {
        let timeNow = Date.now();
        console.log('Getting NXI rest response for ', url);
        return this.http.get(this.serviceUrl + '/billpay' + '/' + url + '?time=' + timeNow);

    }

    public renderFinancialPlanning(): Observable<any> {
        let timeNow = Date.now();
        return this.http.get(this.serviceUrl + '/portfolio/render-financial-plan' + '?time=' + timeNow);
    }

    public renderFinancialPlanningResp(url: string): Observable<any> {
        let timeNow = Date.now();
        return this.http.get(this.serviceUrl + url + '?time=' + timeNow);
    }

    public getAccountByReference(accountRef: string): Observable<any> {
        if (accountRef !== '' && accountRef !== undefined) {
            const options = {
                headers: new HttpHeaders().append('Account', accountRef)
            };
            return this.http.get(this.serviceUrl + '/portfolio/' + 'urn:id:headers.Account' + '/getAccountObj', options);
        } else {
            return this.http.get(this.serviceUrl + '/portfolio/' + accountRef + '/getAccountObj');
        }
    }

    public getBackEndDate(): Observable<any> {
        let timeNow = Date.now();
        return this.http.get(this.serviceUrl + '/portfolio/getBEDate' + '?time=' + timeNow);
    }

    public getAccountList(): Observable<any> {
        this.http.get(this.serviceUrl + '/portfolio/accounts', { responseType: 'json' }).subscribe((data: any) => {
            if (!!data && data.length > 1) {
                this.accountList$.next(data);
            } else {
                this.accountList$.next([]);
            }
        },
            error => {
                this.accountList$.next([]);
            });
        return this.accountListObservable$;
    }
    public redirectToNxiLandingPage(isAdaptive: boolean): Observable<any> {
        let body = this.convertQueryParamToHttpParams({ isAdaptive: isAdaptive });
        return this.http.post(this.serviceUrl + '/landingPage/getLandingPage', body);
    }

    public redirectToLandingPage(): Observable<any> {
        return this.http.post(this.serviceUrl + '/landingPage/getLandingPageAfterDuplicateSession', { responseType: 'json' });
    }

    public getNxiRestResponse(nxiRestUrl: string): Observable<any> {
        return this.http.post(nxiRestUrl, { headers: this.jsonFormHeaders });
    }
    private convertQueryParamToHttpParams(queryParams: Params): HttpParams {
        let param = new HttpParams();
        if (queryParams === null) {
            return param;
        }
        for (let query in queryParams) {
            if (queryParams.hasOwnProperty(query)) {
                param = param.set(query, queryParams[query]);
            }
        }
        return param;
    }
}
